async function getRecommendedProducts(id) {
  const query = `
    query GetProductRecommendations($guid:ID!){
      productRecommendations(productId:$guid,intent: RELATED){
          id
          collections(first:5) {
            edges{
              node{
                title
                onlineStoreUrl
                handle
              }
            }
          }
        }
      }
    `;
  let guid;
  if ( id.includes('gid')) guid = id
  else guid = "gid://shopify/Product/" + id;
  
  const response = await executeQuery(query, { guid });
  
  if (!response.data) return;
  return response.data;
  
}
